import { Headphones } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { coverSrc, coverSrcSet } from "@/lib/coverSrc";

interface FeaturedShow {
  id: string;
  showName: string;
  episodeName: string;
  artworkGradient: string;
  allTimeStreams: number;
  coverUrl?: string | null;
  slug?: string;
}

interface PodcasterCardProps {
  show: FeaturedShow;
}

export const PodcasterCard = ({ show }: PodcasterCardProps) => {
  return (
    <div className="w-full min-w-0">
      <div className="bg-neutral/10 border border-neutral/20 rounded-xl overflow-hidden">
        {/* Artwork */}
        {show.coverUrl ? (
          <div className="aspect-square overflow-hidden">
            <img
              src={coverSrc(show.coverUrl, 200)}
              srcSet={coverSrcSet(show.coverUrl, [200, 280, 400, 560])}
              sizes="(min-width: 1200px) 280px, (min-width: 768px) 240px, 200px"
              alt=""
              role="presentation"
              className="w-full h-full object-cover"
              loading="lazy"
              decoding="async"
              width={280}
              height={280}
            />
          </div>
        ) : (
          <div
            className={`aspect-square ${show.artworkGradient} flex items-center justify-center`}
          >
            <Headphones className="w-12 h-12 sm:w-16 sm:h-16 text-primary-foreground/60" aria-hidden="true" />
          </div>
        )}

        {/* Card Content */}
        <div className="p-4 flex flex-col gap-2">
           <p className="text-primary-foreground text-sm sm:text-base font-display font-semibold truncate">
            {show.showName}
          </p>
          <p className="text-primary-foreground/70 text-xs sm:text-sm line-clamp-2 min-h-[2.5em]">
            {show.episodeName}
          </p>
          {/* Real anchor so crawlers can reach the show page. */}
          <Button
            asChild={!!show.slug}
            variant="default"
            size="sm"
            disabled={!show.slug}
            className="w-full bg-accent hover:bg-accent/90 text-accent-foreground mt-1"
          >
            {show.slug ? (
              <Link to={`/podcast/${show.slug}`}>
                <Headphones className="w-4 h-4 mr-2" aria-hidden="true" />
                Listen Now
              </Link>
            ) : (
              <span>
                <Headphones className="w-4 h-4 mr-2" aria-hidden="true" />
                Listen Now
              </span>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};
